import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IInputMethodBehavior, InputMethodKinds } from "../../../../documaker/domain/format/objects";

export interface IInputMethodBehaviorPropertyEditable {
  inputMethodBehavior(): IPropertyEditable<IInputMethodBehavior>;
  getSelectableInputMethods(): InputMethodKinds[];
}

export function instanceOfIInputMethodBehaviorPropertyEditable(instance: any): instance is IInputMethodBehaviorPropertyEditable {
  return instance
      && instance.getSelectableInputMethods
      && instance.inputMethodBehavior
      && instanceOfIPropertyEditable<IInputMethodBehavior>(instance.inputMethodBehavior());
}
